import { useState } from "react";

export const faqs = [
  { q: "How fast can I get a passport in Southaven, MS?", a: "Our emergency service delivers passports in as little as 24 hours. Expedited takes 3–5 business days. With FedEx's World Hub in Memphis just minutes away, we're especially equipped to handle urgent logistics-industry travel needs." },
  { q: "Where is the nearest passport acceptance facility to Southaven?", a: "The Southaven Post Office on Goodman Road is the most convenient. Memphis facilities across the Tennessee state line are also accessible. We direct you to whichever has the shortest current wait time." },
  { q: "Can FedEx employees in Southaven get expedited passports?", a: "Yes. FedEx World Hub employees and supply chain professionals with urgent international business travel are a core part of our client base in the Memphis metro area." },
  { q: "Is there a Regional Passport Agency near Southaven?", a: "The Atlanta Passport Agency (230 Peachtree St NW, Suite 1000, Atlanta, GA 30303) is the nearest, about 5 hours east via I-22 and I-20. For emergency processing, our courier service is far faster and more convenient — we handle everything remotely." },
  { q: "Do I need an appointment for a passport in Southaven?", a: "Most DeSoto County facilities are walk-in. Memphis facilities may offer appointments. We advise on the best option based on your timeline." },
  { q: "What documents do I need for a passport in Southaven?", a: "Certified birth certificate with raised seal, valid government photo ID, compliant passport photo, and DS-11 or DS-82 form. We verify all documents before your facility visit." },
  { q: "Can I use Memphis passport acceptance facilities from Southaven?", a: "Yes, many Southaven residents use Memphis facilities which are often 15–20 minutes away. We guide you to the best option based on current wait times in both markets." },
  { q: "How much does passport expediting cost from Southaven?", a: "Government fees are $130–$190. Our service fees start at $99 for standard expedited. Emergency 24-hour service is available at higher tiers. Best price guarantee." },
];

export default function SouthavenFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Southaven, MS Passport <span className="text-[#F6C344]">Questions</span>
          </h2>
        </div>
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}